import { render, staticRenderFns } from "./RadarChart.vue?vue&type=template&id=e44901ae"
import script from "../../../scripts/partials/dashboard-charts/RadarChart.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/RadarChart.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports